<div class="transaction-general-dialog">
  <div class="transaction-header">{{ 'Transaction_Dialog_1' | translate }}</div>

  <div class="transaction-activity-container">
    <div class="transaction-activity-row">
      <div class="left">{{ 'Transaction_Dialog_2' | translate }}</div>
      <div class="right">{{ Deposit | balanceFormat }}</div>
    </div>
    <div class="transaction-activity-row">
      <div class="left">{{ 'Transaction_Dialog_3' | translate }}</div>
      <div class="right">{{ TotalBet | balanceFormat }}</div>
    </div>
  </div>
  <div class="transaction-info-container">
    <div class="transaction-info-row">{{ 'Transaction_Dialog_4' | translate }}</div>
    <div class="transaction-info-row">{{ 'Transaction_Dialog_5' | translate }}</div>
    <div class="transaction-info-row">
      <span>
        {{ 'Transaction_Dialog_6' | translate }} <a [href]="'healthUrl' | getEnv" target="_blank">{{ 'Transaction_Dialog_7' | translate }}</a>
      </span>
    </div>
  </div>
  <div class="lower-info-container">
    <span>
      <span> {{ 'Transaction_Dialog_12' | translate }} {{ 'Transaction_Dialog_13' | translate }} {{ 'Transaction_Dialog_14' | translate }} </span>
    </span>
  </div>
  <div class="white-black-text confirm-button border-black" (click)="goToHome()">
    <div class="btn-text">
      {{ 'Confirm_SettingsConsent' | translate }}
    </div>
  </div>
</div>
